export default "__VITE_ASSET__4183d497__"